<div class="form-container edp-form end-contract">
    <form [formGroup]="form">
        <div class="input-container pb-0">

            <div class="d-flex flex-column mb-4">
                <label class="text-label mb-2">{{ "pt.edp.edponline.request.termination.date" | translate }}</label>
                <input
                    type="text"
                    formControlName="date"
                    placeholder="dd/mm/aaaa"
                    mask="00/00/0000"
                    maxlength="10"
                >
                <span class="date-info">{{"pt.edp.edponline.request.termination.date.info" | translate}}</span>
            </div>

            <div class="form-group" *ngIf="!!selectedContract?.HasE && !!selectedContract?.HasG">
                <label class="form-check-label" *ngFor="let item of types">
                    <input
                        class="form-check-input"
                        type="checkbox"
                        [checked]="item.selected"
                        (change)="setTypeDelete(item.id, item.type)"
                    />
                    <span class="form-check-mark"></span>
                    <span class="form-check-name">{{ ("pt.edp.edponline.request.operations.contract." + item.type) | translate }}</span>
                </label>

            </div>

            <div class="mt-5">
                <label class="text-label mb-2">{{ "pt.edp.edponline.request.cancel.period" | translate }}</label>

                <edp-select-list
                    [options]="hours"
                    (nextOptions)="setPeriod($event)"
                ></edp-select-list>
            </div>

        </div>
    </form>
</div>
